'use client'

import { useLocale } from '@/components/LocaleProvider'

export default function Footer() {
  const { t } = useLocale()
  const linkClass = 'font-bold text-foreground/80 hover:text-foreground transition-colors focus-visible:outline-2 focus-visible:outline-black dark:focus-visible:outline-white focus-visible:outline-offset-2 rounded'
  const ariaSuffix = ` - ${t('common.opensInNewWindow')}`

  return (
    <footer className="py-14 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-[3em] border-t border-black/10 dark:border-white/10 mt-14">
      <p className="text-sm text-foreground/60 leading-relaxed">
        {t('footer.beforeLinks')}
        <a href="https://cursor.sh" target="_blank" rel="noopener noreferrer" className={linkClass} aria-label={`Cursor${ariaSuffix}`}>
          {t('footer.linkCursor')}
        </a>
        {t('footer.mid1')}
        <a href="https://nextjs.org" target="_blank" rel="noopener noreferrer" className={linkClass} aria-label={`Next.js${ariaSuffix}`}>
          {t('footer.linkNextjs')}
        </a>
        {t('footer.mid2')}
        <a href="https://tailwindcss.com" target="_blank" rel="noopener noreferrer" className={linkClass} aria-label={`Tailwind${ariaSuffix}`}>
          {t('footer.linkTailwind')}
        </a>
        {t('footer.afterLinks')}
      </p>
    </footer>
  )
}
